/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coach_Mic_ListeningInputs */

const en_us2_coach_mic_listening = /** @type {(inputs: Coach_Mic_ListeningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listening…`)
};

const pt_br2_coach_mic_listening = /** @type {(inputs: Coach_Mic_ListeningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ouvindo…`)
};

const es_419_coach_mic_listening = /** @type {(inputs: Coach_Mic_ListeningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escuchando…`)
};

const pt_pt2_coach_mic_listening = /** @type {(inputs: Coach_Mic_ListeningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A ouvir…`)
};

const fr_fr2_coach_mic_listening = /** @type {(inputs: Coach_Mic_ListeningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`À l'écoute…`)
};

const de_de2_coach_mic_listening = /** @type {(inputs: Coach_Mic_ListeningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hört zu…`)
};

const it_it2_coach_mic_listening = /** @type {(inputs: Coach_Mic_ListeningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In ascolto…`)
};

/**
* | output |
* | --- |
* | "Listening…" |
*
* @param {Coach_Mic_ListeningInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const coach_mic_listening = /** @type {((inputs?: Coach_Mic_ListeningInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coach_Mic_ListeningInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_coach_mic_listening(inputs)
	if (locale === "es-419") return es_419_coach_mic_listening(inputs)
	if (locale === "pt-PT") return pt_pt2_coach_mic_listening(inputs)
	if (locale === "fr-FR") return fr_fr2_coach_mic_listening(inputs)
	if (locale === "de-DE") return de_de2_coach_mic_listening(inputs)
	if (locale === "it-IT") return it_it2_coach_mic_listening(inputs)
	return en_us2_coach_mic_listening(inputs)
});
export { coach_mic_listening as "coach-mic.listening" }